"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GamesByProvider = function (_a) {
    var _b = _a.provider, provider = _b === void 0 ? 'amatic' : _b, _c = _a.data, data = _c === void 0 ? [] : _c, _d = _a.gameCardPlaceholder, gameCardPlaceholder = _d === void 0 ? '' : _d;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var games = data === null || data === void 0 ? void 0 : data.slice(0, 6);
    var router = (0, navigation_1.useRouter)();
    var onClickProvider = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/providers/".concat(provider.toLowerCase())));
    }, [provider, generateUrlWithLang, router]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('games')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.providerImage, onClick: onClickProvider },
            react_1.default.createElement("object", { className: styles_module_scss_1.default.blured, data: "/img/providers/".concat(provider, ".svg"), type: "image/png" },
                react_1.default.createElement("img", { src: "/img/providers/default.svg", alt: provider }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.games }, games === null || games === void 0 ? void 0 : games.map(function (game, idx) {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, { key: "gamesByProvidersSlide".concat(game.id).concat(idx) },
                react_1.default.createElement(react_1.default.Fragment, null,
                    Object.keys(breakpoints).length > 0 &&
                        (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(ui_components_1.MobileGameCard, { key: "".concat(game.id).concat(idx), title: game.title, gameId: game === null || game === void 0 ? void 0 : game.id, slug: game === null || game === void 0 ? void 0 : game.slug, className: styles_module_scss_1.default.mobileGameCard, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL })),
                    Object.keys(breakpoints).length > 0 &&
                        !breakpoints.mobile &&
                        !breakpoints.tablet && (react_1.default.createElement(ui_components_1.DesktopGameCard, { key: "".concat(game.id).concat(idx), gameId: game.id, slug: game.slug, className: styles_module_scss_1.default.desktopGameCard, titleClassName: styles_module_scss_1.default.titleCard, playNowBtnClassName: styles_module_scss_1.default.playNowBtn, playDemoBtnClassName: styles_module_scss_1.default.playDemoBtn, withDemo: (_a = game === null || game === void 0 ? void 0 : game.settings) === null || _a === void 0 ? void 0 : _a['demo'], hasPlayNowIcon: false, hasFavorite: false, title: game.title, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL })))));
        })),
        react_1.default.createElement(ui_components_1.FixedButton, { onClick: onClickProvider, width: "150px" }, t('viewAll'))));
};
exports.default = GamesByProvider;
